import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { NavigationComponent } from "./navigation.component";
import { CommonModule } from "@angular/common";



@NgModule({
    declarations: [NavigationComponent],
    imports: [
        CommonModule,
        RouterModule,

    ],
    exports: [NavigationComponent],
})

export class NavigationModule { }
